/** "Was this useful?" under a paper or a deck (spec §6.4). A second click changes the vote —
 * a second row, and the operator report takes the last one. ▲/▼, not emoji: emoji render
 * differently on every phone and pull the tone towards chat (design v2). */
import { useState } from "react";
import type { Api, FeedbackBody } from "../api/api";
import "../styles/feedback.css";

type Props = {
  api: Api;
  kind: "paper" | "deck";
  refId: string;
  label: string;
};

export function RatingStrip({ api, kind, refId, label }: Props) {
  const [vote, setVote] = useState<1 | -1 | null>(null);
  const [line, setLine] = useState("");
  const [sent, setSent] = useState(false);

  async function post(rating: 1 | -1, body?: string) {
    const payload: FeedbackBody = { kind, ref_id: refId, rating };
    if (body) payload.body = body;
    await api.sendFeedback(payload);
  }

  function choose(rating: 1 | -1) {
    setVote(rating);
    setSent(false);
    void post(rating);
  }

  return (
    <div className="rating" role="group" aria-label={label}>
      <span className="rating__prompt">{label}</span>
      <button className="rating__vote" aria-pressed={vote === 1} onClick={() => choose(1)}>
        <span aria-hidden="true">▲</span> Useful
      </button>
      <button className="rating__vote" aria-pressed={vote === -1} onClick={() => choose(-1)}>
        <span aria-hidden="true">▼</span> Not useful
      </button>
      {vote !== null && !sent && (
        <form
          className="rating__line"
          onSubmit={(e) => {
            e.preventDefault();
            void post(vote, line.trim()).then(() => {
              setSent(true);
              setLine("");
            });
          }}
        >
          <label>
            Anything else? A person reads these.
            <input value={line} onChange={(e) => setLine(e.target.value)} maxLength={4000} />
          </label>
          <button className="button button--primary" disabled={!line.trim()}>
            Send
          </button>
        </form>
      )}
      {sent && <span className="muted">Thanks.</span>}
    </div>
  );
}
